import { Injectable, NgZone, Output, EventEmitter } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { tap, finalize } from 'rxjs/operators';
import { BaseUrl } from '../framework/constants/url-constants';
import { AppInsightsService } from '../framework/service/app-insights.service';
import { Utility } from '../framework/utils/utility';
import { BehaviorSubject } from 'rxjs';
import { ImageUrl } from '../framework/constants/image--url-constant';
import { MatDialog } from '@angular/material/dialog';

const authHeaderString = 'X-Authorization';
const contentTypeHeaderString = 'application/json';

const signInHttpHeaders = new HttpHeaders({
  'Content-Type': contentTypeHeaderString
});
const exposeXAuthHeader = new HttpHeaders({
  'Access-Control-Expose-Headers': authHeaderString,
});

//@Directive()
@Injectable()
export class SessionsService {
  @Output() passwordAboutToExpiredFlag: EventEmitter<boolean> = new EventEmitter();
  private readonly logoUrl = new BehaviorSubject<string>(ImageUrl.LOGO_IMAGE);
  currentLogo = this.logoUrl.asObservable();
  isPes:string;

  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
    private readonly zone: NgZone,
    private readonly appInsightsService: AppInsightsService,
    private readonly dialogRef: MatDialog
  ) { }

  changeLogo(logo: string){
    this.logoUrl.next(logo);
  }

  signin(data: any): any {
    data.appId = localStorage.getItem('appId')
    //data.clientId = localStorage.getItem('clientId')
    return this.http.post<any>(BaseUrl.AUTHENTICATION + '/service-user/login', data, { headers: signInHttpHeaders, observe: 'response' })
      .pipe(
        tap(resp => {
          this.resolveSessionParams(resp);

        })
      );
  }

  signout() {
    this.appInsightsService.clearAuthenticatedUserContext();
    this.dialogRef.closeAll();
    return this.http.get(BaseUrl.AUTHENTICATION + '/service-user/logout')
      .pipe(finalize(() => this.onSignoutTap()));
  }

  onSignoutTap() {
    
    this.zone.run(() => {
      // window.location.href = `${localStorage.getItem('moodleUrl')}/login/logout.php`;
      this.dialogRef.closeAll();
      this.router.navigate(['/sessions/signin']);
    });

    let appId = localStorage.getItem('appId');
    this.isPes = localStorage.getItem('IsPES');
      localStorage.clear();
      localStorage.setItem('appId', appId);
      localStorage.setItem('IsPES', this.isPes);
  }

  resolveSessionParams(resp) {
    const xAuthToken = resp.headers.get(authHeaderString).split(' ');
    const token = xAuthToken[1];
    localStorage.setItem('token', token);
    if (resp.body.heartbeat) {
      localStorage.setItem('session', btoa(JSON.stringify(resp.body)));
    }
  }

  hasResource(auth: string[]) {

    if (localStorage.getItem('token') && auth) {
      const payload = atob(localStorage.getItem('token').split('.')[1]);
      const permissions = JSON.parse(payload).listResource;

      if (auth[1] && permissions.filter(feature => +feature.fid === +auth[0])[0]) {
        return !!permissions.filter(feature => +feature.fid === +auth[0])[0].opId.find(operation => +operation === +auth[1]);
      } else {
        return !!permissions.find(permission => +permission.fid === +auth[0]);
      }
    }
    return false;
  }

  getRoleId() {
    if (localStorage.getItem('token')) {
      const tokenBody = atob(localStorage.getItem('token').split('.')[1]);
      const payload = JSON.parse(tokenBody);
      return payload.roleId;
    }
    return 0;
  }

  refreshToken() {

    return this.http.get<any>(`${BaseUrl.AUTHENTICATION}/refreshToken`, { observe: 'response' })
      .pipe(
        tap(resp => {
          this.resolveSessionParams(resp);
        }));
  }
  isRehabSupervisor(roleList) {
    let isValid = false;
    const roleId = this.getRoleId();
    if (roleId !== -1) {
      const role = Utility.getObjectFromArrayByKeyAndValue(roleList, 'roleId', roleId);
      if (role !== null && role.identifier === 'RHS') {
        isValid = true;
      }
    }
    return isValid;
  }
  getClientOrganizations() {
    const href = `${BaseUrl.USER}/user/organizations`;
    return this.http.get<any>(href);
  }

  changeEstablishment(estbId) {
    return this.http.post<any>(`${BaseUrl.AUTHENTICATE}/changeEstablishment/${estbId}`, estbId, { headers: signInHttpHeaders, observe: 'response' })
      .pipe(
        tap(resp => {
          this.resolveSessionParams(resp);
        }),
      );
  }

  setPasswordAboutToExpireFlag(flag) {
    localStorage.setItem('passwordCheck', JSON.stringify(flag));
    this.passwordAboutToExpiredFlag.emit(flag);

  }

  getClientDetails() {
    const url = BaseUrl.CLIENT_URL;
    const href = `${BaseUrl.USER}/clients/getByUrl`;
    return this.http.get<any>(href, { params: new HttpParams().set('url', url) });
  }

  kwSignin(data: any): any {
    const body = JSON.stringify(data);
    return this.http.post<any>(BaseUrl.AUTHENTICATION + '/login', body, { headers: signInHttpHeaders, observe: 'response' })
      .pipe(
      tap(resp => {
        this.resolveSessionParams(resp);
      }));
  }

  kwSignout() {
    this.appInsightsService.clearAuthenticatedUserContext();
    this.dialogRef.closeAll();
    return this.http.get(BaseUrl.AUTHENTICATE + '/logout')
      .pipe(finalize(() => this.onSignoutTap()));
  }

  ssoLogin(data: any, type:string): any {
   
    return this.http.post<any>( BaseUrl.AUTHENTICATION + '/v2/login/'+type, data, { headers: signInHttpHeaders, observe: 'response' })
      .pipe(
        tap(resp => {
          this.resolveSessionParams(resp);

        })
      );
  }

  getIsPes() {
    const href = `${BaseUrl.AUTHENTICATION}/getIsPes`;
    return this.http.get<any>(href);
  }

  getUserEstablishments() {
    return this.http.get<any>(`${BaseUrl.PROFILE}/userorganizations`);
  }
  
  refreshTokenOnEstablishmentChange(establismentId) {

    return this.http.post<any>(`${BaseUrl.AUTHENTICATION}/changeEstablishment/${establismentId}`, null,
      { headers: exposeXAuthHeader, observe: 'response' })
      .pipe(
      tap(resp => {
        this.resolveSessionParams(resp);
      }));
  }
}
